module.exports = __webpack_public_path__ + "img/classListBanner.2b98557d.png";